import { IPromise } from 'q';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import WebHttpClient from '~src/httpClient/WebHttpClient';
import { SiteStore } from '~src/siteManagement/sagas/SiteStore';

import { SiteNamesRequest, SitesAndTenantsInfoRequest } from '../../bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { SitesAndTenantsInfoRequestAction, sitesAndTenantsInfoRequestSucceeded } from '../actions/SitesAndTenantsInfoRequestAction';
import { SiteNamesRequestAction, siteNamesRequestSucceeded } from '../actions/SitesNamesRequestAction';
import { GetSitesAndTenantsAcrossAllPodsRequest } from '../serverApi/requests/GetSitesAndTenantsAcrossAllPodsRequest';
import { ISiteNameSansId } from '../serverApi/types/ISiteNameSansId';
import { ISitesAndTenantsInfo } from '../serverApi/types/ISitesAndTenantsInfo';
import { SiteNameSansIds } from '../services/resources/SiteNameSansIds';

export const MAX_IN_CLAUSE_VALUES: number = 1000;

export function* handleGetSitesRequest(action: SiteNamesRequestAction) {
  try {
    const sites: ReadonlyArray<ISiteNameSansId> = yield call(getSiteNamesRequest);
    if (sites.length < 1) {
      yield put(requestFailed(Messages.errorUnknown()));
      return;
    }
    yield put(siteNamesRequestSucceeded(sites));
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function getSiteNamesRequest(): IPromise<ISiteNameSansId[]> {
  const siteStore = new SiteStore(SiteNameSansIds.instance);
  return siteStore.getAll();
}

export function* handleGetSitesAndTenantsInfoRequest(action: SitesAndTenantsInfoRequestAction) {
  try {
    const sitesAndTenantsInfo: ISitesAndTenantsInfo = yield call(getSitesAndTenantsInfoRequest);
    yield put(sitesAndTenantsInfoRequestSucceeded(sitesAndTenantsInfo));
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function getSitesAndTenantsInfoRequest(): Promise<ISitesAndTenantsInfo> {
  return WebHttpClient.sendRequest(new GetSitesAndTenantsAcrossAllPodsRequest())
    .then((sitesAndTenantsInfo: ISitesAndTenantsInfo) => {
      if (sitesAndTenantsInfo.errors) {
        return Promise.reject(sitesAndTenantsInfo.errors[0] && sitesAndTenantsInfo.errors[0].code);
      }
      return Promise.resolve(sitesAndTenantsInfo);
  });
}

export function* rootSiteSagas(): SagaIterator {
  yield takeLatest(SiteNamesRequest, handleGetSitesRequest);
  yield takeLatest(SitesAndTenantsInfoRequest, handleGetSitesAndTenantsInfoRequest);
}

